import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/header/h2501.png'


const _withScopeId = n => (_pushScopeId("data-v-95acc6c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container lazyload" }
const _hoisted_2 = {
  id: "h_top",
  class: "lazyload"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "ララちゃんランドセル",
    class: "lazyload",
    "data-src": "../../assets/images/header/h2501.png",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("span", null, "ララちゃんランドセル")
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h_nav lazyload" }, [
  /*#__PURE__*/_createElementVNode("nav", {
    id: "gNav",
    role: "navigation"
  }, [
    /*#__PURE__*/_createElementVNode("ul", { class: "nav" }, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/lineup" }, "ランドセル一覧"),
        /*#__PURE__*/_createElementVNode("ul", { class: "sub-menu" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/order" }, "オーダーメイド")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/lineup/cosmorainbow" }, "コスモレインボー")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/collection" }, "コレクション")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/magicalbelt" }, "別売マジかるベルト")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/lineup/lessonbag" }, "レッスンバッグ")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/searchconditions" }, "ランドセルを探す"),
        /*#__PURE__*/_createElementVNode("ul", { class: "sub-menu" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/beginning" }, "初めてのランドセル選び")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/boy" }, "男の子向けのランドセル")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/girl" }, "女の子向けのランドセル")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/design" }, "デザインから探す")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/color" }, "色から探す")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/secret" }, "ララちゃんの特徴"),
        /*#__PURE__*/_createElementVNode("ul", { class: "sub-menu" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/bellbio5" }, "生地について")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/majicalbelt" }, "マジかるベルトについて")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/secret" }, "こだわり機能")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/news/category/randoseru_pickup" }, "ランドセル図鑑")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/realcheck" }, "ランドセルを試す"),
        /*#__PURE__*/_createElementVNode("ul", { class: "sub-menu" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/showroom" }, "直営ショールーム")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/showroom/exhibition" }, "展示会")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/showroom/agency" }, "全国取扱店")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "https://raraya-rarachan.com/",
              rel: "noopener noreferrer",
              target: "_blank"
            }, "おうちでラン活")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/catalog" }, "カタログ請求"),
        /*#__PURE__*/_createElementVNode("ul", { class: "sub-menu" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://catalog.raraya.co.jp/2027/request/form?id=1" }, "2027年度カタログ")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/hookerchart" }, "安全フッカー請求")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/inquiry" }, "お問い合わせ"),
        /*#__PURE__*/_createElementVNode("ul", { class: "sub-menu" }, [
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/faq" }, "よくある質問")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "https://raraya-rarachan.com/raraya-syuri01/",
              rel: "noopener noreferrer",
              target: "_blank"
            }, "修理専用窓口")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/guide/after-service" }, "アフターサービス")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", {
              href: "https://memorial.raraya-rarachan.com/",
              rel: "noopener noreferrer",
              target: "_blank"
            }, "ランドセルリメイク")
          ]),
          /*#__PURE__*/_createElementVNode("li", null, [
            /*#__PURE__*/_createElementVNode("a", { href: "https://raraya.co.jp/shipment" }, "商品のお届け予定")
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "MENU", -1))
const _hoisted_10 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<ul class=\"nav\" data-v-95acc6c2><li data-v-95acc6c2><a href=\"https://raraya.co.jp/lineup\" data-v-95acc6c2>ランドセル一覧</a><ul class=\"sub-menu\" data-v-95acc6c2><li data-v-95acc6c2><a href=\"https://raraya.co.jp/order\" data-v-95acc6c2>オーダーメイド</a></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/lineup/cosmorainbow\" data-v-95acc6c2>コスモレインボー</a></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/collection\" data-v-95acc6c2>コレクション</a></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/magicalbelt\" data-v-95acc6c2>別売マジかるベルト</a></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/lineup/lessonbag\" data-v-95acc6c2>レッスンバッグ</a></li></ul></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/searchconditions\" data-v-95acc6c2>ランドセルをさがす</a><ul class=\"sub-menu\" data-v-95acc6c2><li data-v-95acc6c2><a href=\"https://raraya.co.jp/beginning\" data-v-95acc6c2>初めてのランドセル選び</a></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/boy\" data-v-95acc6c2>男の子向けのランドセル</a></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/girl\" data-v-95acc6c2>女の子向けのランドセル</a></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/design\" data-v-95acc6c2>デザインから探す</a></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/color\" data-v-95acc6c2>色から探す</a></li></ul></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/secret\" data-v-95acc6c2>ララちゃんの特徴</a><ul class=\"sub-menu\" data-v-95acc6c2><li data-v-95acc6c2><a href=\"https://raraya.co.jp/bellbio5\" data-v-95acc6c2>生地について</a></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/majicalbelt\" data-v-95acc6c2>マジかるベルトについて</a></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/secret\" data-v-95acc6c2>こだわり機能</a></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/news/category/randoseru_pickup\" data-v-95acc6c2>ランドセル図鑑</a></li></ul></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/realcheck\" data-v-95acc6c2>ランドセルを試す</a><ul class=\"sub-menu\" data-v-95acc6c2><li data-v-95acc6c2><a href=\"https://raraya.co.jp/showroom\" data-v-95acc6c2>直営ショールーム</a></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/showroom/exhibition\" data-v-95acc6c2>展示会</a></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/showroom/agency\" data-v-95acc6c2>全国取扱店</a></li><li data-v-95acc6c2><a href=\"https://raraya-rarachan.com/\" rel=\"noopener noreferrer\" target=\"_blank\" data-v-95acc6c2>おうちでラン活</a></li></ul></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/catalog\" data-v-95acc6c2>カタログ請求</a><ul class=\"sub-menu\" data-v-95acc6c2><li data-v-95acc6c2><a href=\"https://catalog.raraya.co.jp/2027/request/form?id=1\" data-v-95acc6c2>2027年度カタログ</a></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/hookerchart\" data-v-95acc6c2>安全フッカー請求</a></li></ul></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/inquiry\" data-v-95acc6c2>お問い合わせ</a><ul class=\"sub-menu\" data-v-95acc6c2><li data-v-95acc6c2><a href=\"https://raraya.co.jp/faq\" data-v-95acc6c2>よくある質問</a></li><li data-v-95acc6c2><a href=\"https://raraya-rarachan.com/raraya-syuri01/\" rel=\"noopener noreferrer\" target=\"_blank\" data-v-95acc6c2>修理専用窓口</a></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/guide/after-service\" data-v-95acc6c2>アフターサービス</a></li><li data-v-95acc6c2><a href=\"https://memorial.raraya-rarachan.com/\" rel=\"noopener noreferrer\" target=\"_blank\" data-v-95acc6c2>ランドセルリメイク</a></li><li data-v-95acc6c2><a href=\"https://raraya.co.jp/shipment\" data-v-95acc6c2>商品のお届け予定</a></li></ul></li></ul>", 1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FavoriteButton = _resolveComponent("FavoriteButton")!
  const _component_ModeButton = _resolveComponent("ModeButton")!

  return (_openBlock(), _createElementBlock("header", {
    id: "header",
    class: _normalizeClass({ 'is-menu-open': _ctx.menuVisible })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", {
          class: _normalizeClass([{ active: _ctx.menuVisible }, "h_logo"])
        }, _hoisted_4, 2),
        _hoisted_5,
        _createVNode(_component_FavoriteButton, { class: "hide-desktop" }),
        _createVNode(_component_ModeButton, {
          isMobile: true,
          class: "header-mode-button"
        }),
        _createElementVNode("div", {
          class: _normalizeClass([[{ active: _ctx.menuVisible }, { 'is-fixed': _ctx.menuVisible }], "hamburger pc-none"]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
        }, _hoisted_10, 2),
        _createElementVNode("nav", {
          class: _normalizeClass([{ active: _ctx.menuVisible }, "globalMenuSp pc-none"])
        }, _hoisted_12, 2)
      ])
    ])
  ], 2))
}